// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/Header";
import { PostApi } from "../../../ApiClient/PostApi";
import { getLoginStatus, setLoginStatus } from "../../../Utils/AuthCheck";
import { error_toaster, success_toaster } from "../../toaster/Toaster";
import { useNavigate } from "react-router-dom/dist";
import { Loader2 } from "../../loader/Loader";
import { useFormik } from "formik";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import * as Yup from "yup";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
export default function Register() {
  const navigate = useNavigate();
  useEffect(() => {
    if (getLoginStatus() === "true") {
      navigate("/");
    }
  }, []);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  // const [phone, setPhone] = useState("");

  const initialValues = {
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    phone: "",
  };
  const loginSchema = Yup.object({
    email: Yup.string().email().required("Please enter your email"),
    password: Yup.string().min(6).required("Please enter your password"),
    firstName: Yup.string().required("Please enter your First Name"),
    lastName: Yup.string().required("Please enter your Last Name"),
    phone: Yup.string().required("Please enter your Phone Number"),
  });

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: loginSchema,
      onSubmit: async (values, action) => {
        let res = await PostApi("users/registration", {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          phone: values.phone,
          password: values.password,
        });
        if (res.data.status === "1") {
          localStorage.setItem("email", res.data.data.email);
          setLoading(false);
          // setLoginStatus(true);
          // localStorage.setItem("BearerToken", res.data.data.accessToken);
          // localStorage.setItem('firstName', res.data.data.firstName);
          // localStorage.setItem('lastName', res.data.data.lastName);
          navigate("/email_otp");
          success_toaster(res.data.message);
        } else {
          setLoading(false);
          error_toaster(res.data.message);
        }
      },
    });

  const handlePhoneChange = (phone) => {
    handleChange({ target: { name: "phone", value: phone } });
  };

  return (
    <>
      <Header />
      <section className="lg:h-[calc(100vh-80px)] flex items-center lg:my-0 my-10">
        {loading ? (
          <Loader2 />
        ) : (
          <section className="xl:w-2/6 lg:w-3/6 sm:w-3/5 w-10/12 mx-auto flex flex-col justify-center gap-y-8 py-8">
            <div className="flex justify-center">
              <Link to="/">
                <img src="images/logo2.webp" alt="logo" className="w-48" />
              </Link>
            </div>
            <div className="flex justify-between items-center">
              <h3 className="font-bold sm:text-4xl text-3xl">Create Account</h3>
              <Link
                to="/login"
                className="text-themeBlue2 font-medium text-xl hover:text-themeRed"
              >
                Login
              </Link>
            </div>
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div className="grid sm:grid-cols-2 gap-x-2 gap-y-8">
                <div className="space-y-2">
                  <div>
                    <label htmlFor="fName" className="font-normal text-base">
                      First Name
                    </label>
                  </div>
                  <div>
                    <input
                      value={values.firstName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      className="w-full text-sm font-normal border border-themeGray px-2 py-3 rounded 
                    bg-themeGray focus:bg-transparent"
                    />
                    {errors.firstName && touched.firstName && (
                      <div className="px-5 text-red-600 space-y-1 pb-1">
                        <p>{errors.firstName}</p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="space-y-2">
                  <div>
                    <label htmlFor="lName" className="font-normal text-base">
                      Last Name
                    </label>
                  </div>
                  <div>
                    <input
                      value={values.lastName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      className="w-full text-sm font-normal border border-themeGray px-2 py-3 rounded 
                    bg-themeGray focus:bg-transparent"
                    />
                    {errors.lastName && touched.lastName && (
                      <div className="px-5 text-red-600 space-y-1 pb-1">
                        <p>{errors.lastName}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="space-y-2">
                <div>
                  <label htmlFor="email" className="font-normal text-base">
                    Email
                  </label>
                </div>
                <div>
                  <input
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="email"
                    name="email"
                    placeholder="example123@cmail.com"
                    className="w-full text-sm font-normal border border-themeGray px-2 py-3 rounded 
                    bg-themeGray focus:bg-transparent"
                  />
                  {errors.email && touched.email && (
                    <div className="px-5 text-red-600 space-y-1 pb-1">
                      <p>{errors.email}</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="space-y-2">
                <div>
                  <label htmlFor="phone" className="font-normal text-base">
                    Phone Num.
                  </label>
                </div>
                <div>
                  <div className="">
                    <PhoneInput
                      name="phone"
                      id="phone"
                      inputStyle={{
                        display: "block",
                        border: "transparent",
                        width: "100%",
                        paddingTop: "24px",
                        paddingBottom: "24px",
                        background: "#F4F7FF",
                      }}
                      country={"pk"}
                      enableSearch={true}
                      value={values.phone}
                      onChange={handlePhoneChange}
                      onBlur={handleBlur}
                    />
                  </div>
                  {errors.phone && touched.phone && (
                    <div className="px-5 text-red-600 space-y-1 pb-1">
                      <p>{errors.phone}</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="space-y-2">
                <div>
                  <label htmlFor="password" className="font-normal text-base">
                    Password
                  </label>
                </div>
                <div className="relative">
                  <button
                    onClick={() => setVisible(!visible)}
                    type="button"
                    className="text-black text-opacity-40 absolute right-4 top-1/2 -translate-y-1/2"
                  >
                    {visible ? (
                      <AiOutlineEye size={28} />
                    ) : (
                      <AiOutlineEyeInvisible size={28} />
                    )}
                  </button>
                  <input
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type={visible ? "text" : "password"}
                    name="password"
                    placeholder="******"
                    className="w-full text-sm font-normal border border-themeGray px-2 py-3 rounded 
                    bg-themeGray focus:bg-transparent"
                  />
                </div>
                <div>
                  {errors.password && touched.password && (
                    <div className="px-5 text-red-600 space-y-1 pb-1">
                      <p>{errors.password}</p>
                    </div>
                  )}
                </div>
              </div>
              <div>
                <button
                  type="submit"
                  className="bg-themeBlue px-14 py-2 rounded border border-themeBlue text-white 
              hover:bg-transparent hover:text-themeBlue font-medium text-xl"
                >
                  Signup
                </button>
              </div>
            </form>
          </section>
        )}
      </section>
    </>
  );
}
